import Api from "@/api/api";

export default {
    getVehicleUserMap () {
       return Api.get('/api/Vehicle/GetVehicleUserMap');
    },
    updateVehicleUserMap (id, body) {
       return Api.put('api/Vehicle/UpdateVehicleUserMap', body);
    },
}